import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const postCreateCodeCountry = (params) => {
    return axios.post(`${backendHost}/api/admin/code_country`, params);
};
